const reviewData = [
  {
    reviewer: "Gopinath Ravi",
    role: "Video producer",
    company: "Skill-Lync",
    content: "Overall contribution to the project is good and the design knowledge. Hope you continue with the same attitude so that you learn and prosper."
  },
  {
    reviewer: "Vimalraj",
    role: "Co-Founder",
    company: "Waste Paper",
    content: "Really he is very good designer and very talented person and very hard worker and waste paper team all are satisfied for the logo design and logo looking premium"
  },
  {
    reviewer: "Jamal Azharudeen",
    role: "Graphic Designing",
    company: "ABN Junction",
    content: "You have a great skill set and passion to do your works which reflects in the outcome of the works. Keep it up you may reach many heights."
  },
  {
    reviewer: "Aravind",
    role: "Design Lead",
    company: "Daily Design",
    content: "I'm happy with professional way how Dhanush moves and I liked his creative thinking."
  },
  {
    reviewer: "Vamsi Raju",
    role: "Founder",
    company: "United Beings Foundation",
    content: "Dhanush is young and dymanite.., his way of seeing things is way to ahead the trend. Dhanush has full potential to become a trend setter in terms of designing. Kudos to your future endeavours."
  },
  {
    reviewer: "Sai saran",
    role: "Co-Founder",
    company: "Waste Paper",
    content: "Really very satisfied about your work. its very better and Thank you for those humble service"
  },
  {
    reviewer: "Lakshadhipa Saravanan",
    role: "Designing Head",
    company: "ABN Junction",
    content: "On time worker, very satisfied work, Good listening skill."
  },
  {
    reviewer: "Udaya Priyanka",
    role: "Project Head",
    company: "United Beings Foundation",
    content: "Great work. Thank you for delivering it on time."
  }
];

export default reviewData;